import { render, staticRenderFns } from "./VerticalScale.vue?vue&type=template&id=3e48e8da&scoped=true&"
import script from "./VerticalScale.vue?vue&type=script&lang=js&"
export * from "./VerticalScale.vue?vue&type=script&lang=js&"
import style0 from "./VerticalScale.vue?vue&type=style&index=0&id=3e48e8da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e48e8da",
  null
  
)

export default component.exports